import React from "react";
import { IonRouterLink } from "@ionic/react";

import { AppCards, Breadcrumbs } from "../../components";

import Risorsa from "../../assets/images/Risorsa.svg";
import Pratiche from "../../assets/images/praticha.svg";

const Services = () => {
  const breadcrumbEntries = [{ title: "Servizi" }];
  return (
    <>
      <div className="app-container">
        <Breadcrumbs items={breadcrumbEntries} />
        <div className="app-page-wrapper flex-center-responsive services-page">
          <IonRouterLink href="/servizi/auto">
            <AppCards title="Pratiche auto e trasporti" image={Risorsa} />
          </IonRouterLink>

          <IonRouterLink href="/servizi/amministrative">
            <AppCards title="Pratiche amministrative" image={Pratiche} />
          </IonRouterLink>
        </div>
      </div>
    </>
  );
};

export default Services;
